import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

import BayDrawer from '../BayDrawer';
import BayModal from '../BayModal';
import BayToast from '../BayToast';
import ActAsModal from '../TopNav/components/ActAsModal';
import AddEditCompanyLinkDrawer from '../TopNav/components/AddEditCompanyLinkDrawer';
import FeatureMenu from '../TopNav/components/FeatureMenu';
import MyAccountClient from '../TopNav/components/MyAccountClient';
import MyAccountSocial from '../TopNav/components/MyAccountSocial';
import NotificationFeed from '../TopNav/components/NotificationFeed';
import NotificationFeedSocial from '../TopNav/components/NotificationFeedSocial';
import QuickLinksMenu from '../TopNav/components/QuickLinksMenu';
import QuickLinksModal from '../TopNav/components/QuickLinksModal';
import SettingsMenu from '../TopNav/components/SettingsMenu';
import SnoozeModal from '../TopNav/components/SnoozeModal';
import { useHashCheck } from '../utilities/hook/useHashCheck';

const navDrawerTitleEnum: Record<string, string> = {
	notifications: 'Notifications',
	links: 'Quick Links',
	feature: 'Product Updates',
	settings: 'Settings',
	user: 'My Account',
};

interface QuickLink {
	id: number;
	src: string;
	ssostatus?: string;
	label: string;
	publicid?: string;
	[key: string]: any;
}

interface QuickLinksDataObject {
	quicklinks?: QuickLink[];
	[key: string]: any;
}

interface User {
	ActingAsPUBLICID?: string;
	PUBLICID?: string;
	[key: string]: any;
}

interface QuickLinkService {
	editQuickLinks: (_params: any) => Promise<any>;
	deletePersonalLinks: (_params: any) => Promise<any>;
	quickLinkLogin?: (_params: any) => Promise<any>;
	linksConnectReconnect?: (_params: any) => Promise<any>;
	updatePersonalSSOLink?: (_params: any) => Promise<any>;
	processPersonalAndWebLinks?: (_params: any) => Promise<any>;
	updatePersonalSSOLayout?: (_params: any) => Promise<any>;
	processAgentSSO?: (_params: any) => Promise<any>;
	[key: string]: any;
}

interface SupportedLanguage {
	[key: string]: any;
}

interface ShowCompanyLinkDrawer {
	mode: string;
	isweb: boolean;
	showDrawer: boolean;
}

interface SnackbarState {
	show: boolean;
	description: string;
	variant?: string;
}

interface SnoozeModalData {
	id?: string | number;
	title?: string;
	[key: string]: any;
}

export interface BayNavDrawerProps {
	[key: string]: any;
	t: (_key: string) => string;
	user: User;
	menuType: string;
	setMenuType: (_type: string) => void;
	showOffCanvas: boolean | string;
	withBanners?: any;
	setShowOffCanvas: (_show: boolean) => void;
	quickLinksDataObject: QuickLinksDataObject | Record<string, any>;
	quickLinkService: QuickLinkService;
	enableTestimonialTree: boolean;
	notificationsArray: any[];
	setNotificationsArray: (_notifications: any[]) => void;
	settingsOptions?: any;
	showFeatureButton: boolean | string;
	featureList: any[] | Record<string, any>;
	setFeatureFunc: (_value: any) => void;
	productStages?: any;
	setIsDrawerOpen: (_isOpen: boolean) => void;
	platformType: string;
	reqAccess?: any;
	fetchQuickLinksFunc: () => void | Promise<void>;
	fetchNotificationsFunc?: () => void | Promise<void>;
	updateNavSettings: (_value: boolean) => void;
	alertAudio: boolean;
	showAnnouncementBanners?: boolean;
	showApiTokenButton: boolean;
	showLaunchpadButton: boolean;
	showLaunchpadUpgradeButton: boolean;
	updateLaunchpadApi: (_data: any) => void;
	selectLaunchpadSettingsData?: any;
	enableTranslations: boolean;
	currentLanguage: string;
	onLanguageChange: (_language: string) => void;
	supportedLanguages: SupportedLanguage[] | string[];
	weglotReady: boolean;
	appSettings?: Record<string, any>;
	isMobileView?: boolean;
}

const BayNavDrawer: React.FC<BayNavDrawerProps> = (props) => {
	const {
		t,
		user,
		menuType,
		setMenuType,
		showOffCanvas,
		withBanners,
		setShowOffCanvas,
		quickLinksDataObject,
		quickLinkService,
		enableTestimonialTree,
		notificationsArray,
		setNotificationsArray,
		settingsOptions,
		showFeatureButton,
		featureList,
		setFeatureFunc,
		productStages,
		setIsDrawerOpen,
		platformType,
		reqAccess,
		fetchQuickLinksFunc,
		fetchNotificationsFunc,
		updateNavSettings,
		alertAudio,
		showAnnouncementBanners,
		showApiTokenButton,
		showLaunchpadButton,
		showLaunchpadUpgradeButton,
		updateLaunchpadApi,
		selectLaunchpadSettingsData,
		enableTranslations,
		currentLanguage,
		onLanguageChange,
		supportedLanguages,
		weglotReady,
		appSettings,
		isMobileView,
	} = props;

	const [showActingAsModal, setShowActingAsModal] = useState<boolean>(false);
	const [showQuickLinksModal, setShowQuickLinksModal] = useState<boolean>(false);
	const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
	const [showSnoozeModal, setShowSnoozeModal] = useState<boolean>(false);

	const [editQuickLinksData, setEditQuickLinksData] = useState<any>({});
	const [editQuickLinksDataUser, setEditQuickLinksDataUser] = useState<any>({});
	const [globalQLData, setGlobalQLData] = useState<any>({});
	const [groupIdArray, setGroupIdArray] = useState<any[]>([]);
	const [officeIdArray, setOfficeIdArray] = useState<any[]>([]);
	const [currentSSO, setCurrentSSO] = useState<any>({});
	const [showCompanyLinkDrawer, setShowCompanyLinkDrawer] = useState<ShowCompanyLinkDrawer>({
		mode: 'Edit',
		isweb: true,
		showDrawer: false,
	});
	const [searchLinks, setSearchLinks] = useState<string>('');
	const [quickLinksType, setQuickLinksType] = useState<string>('');
	const [quickLinksObject, setQuickLinksObject] = useState<QuickLink | null>(null);
	const [isUpdateSSO, setIsUpdateSSO] = useState<boolean>(false);
	const [FilterLabel, setFilterLabel] = useState<string[]>([
		'All',
		'Personal',
		'Company',
		'SSO',
	]);
	const [showFilterDropdown, setShowFilterDropdown] = useState<boolean>(false);
	const [focusSearch, setFocusSearch] = useState<boolean>(false);
	const [snoozeModalData, setSnoozeModalData] = useState<SnoozeModalData>({});
	const [ssoIdLinks, setSsoIdLinks] = useState<any[]>([]);
	const [snackbar, setSnackbar] = useState<SnackbarState>({
		show: false,
		description: '',
	});
	const [linkArrayList, setLinkArrayList] = useState<QuickLink[]>([]);

	const isClientSettings = platformType === 'client';

	useEffect(() => {
		if (quickLinksDataObject?.quicklinks?.length) {
			const filteredLinks = quickLinksDataObject.quicklinks.filter((link) => {
				const companyWebSsoCondn =
					(link.id === 1 &&
						link.src !== 'sso:28' &&
						link.ssostatus !== 'false') ||
					(link.src === 'sso:28' && enableTestimonialTree);
				const personalLinkCondn = link.id === 2 && !link.src.startsWith('sso');
				return (
					(companyWebSsoCondn || personalLinkCondn) &&
					link.label.toLowerCase().includes(searchLinks.toLowerCase())
				);
			});
			setLinkArrayList(filteredLinks);
		}
	}, [quickLinksDataObject, searchLinks, enableTestimonialTree]);

	useEffect(() => {
		setIsDrawerOpen(!!showOffCanvas);
		if (menuType === 'links') {
			setFilterLabel(['All', 'Personal', 'Company', 'SSO']);
			setShowFilterDropdown(false);
		}
	}, [showOffCanvas, menuType, setIsDrawerOpen]);

	// Custom hash checking with the useHashCheck hook
	useHashCheck({
		help_center: () => {
			(window as any).ZohoHCAsap?.Action('open', { tab: 'KB' });
		},
		profile_slide: () => {
			setShowOffCanvas(true);
			setMenuType('user');
		},
		product_updates: () => {
			setShowOffCanvas(true);
			setMenuType('feature');
		},
	});

	const handleWebDrawerClose = () => {
		setShowCompanyLinkDrawer({ ...showCompanyLinkDrawer, showDrawer: false });
	};

	const iqQuickLinksEdit = async (
		publicid: string,
		web_src: string,
		sso_src: string,
		linkItem?: QuickLink,
		type?: string,
		showDrawer: boolean = false,
	) => {
		let connectedUserData: any = {};
		setEditQuickLinksData({});
		const Response = await quickLinkService.editQuickLinks({
			publicid,
			web_src: linkItem?.src,
			sso_src,
		});
		if (Response?.status === 0) {
			const res_office = Response?.office_list;
			const res_Access = Response?.access_group_list;
			const res_sso = Response?.sso_list;
			const newOfficesArray = Array.isArray(res_office)
				? res_office?.map((e: any) => {
					return {
						label: `${e.officename}`,
						value: `${e.officeid}`,
					};
				})
				: [];
			const accessGroupArray = Array.isArray(res_Access)
				? res_Access?.map((e: any) => {
					return {
						label: `${e.accessgroupname}`,
						value: `${e.accessgroupid}`,
					};
				})
				: [];
			setEditQuickLinksData(Response?.quicklink_data);
			setEditQuickLinksDataUser(Response?.QUICKLINK_DATA_USER ?? {});
			setGlobalQLData(Response?.QUICKLINK_GLOBAL_DATA_USER ?? {});
			connectedUserData = Response?.QUICKLINK_DATA_USER ?? {};
			setOfficeIdArray(newOfficesArray);
			setGroupIdArray(accessGroupArray);
			if ((linkItem && type === 'Status') || showDrawer) {
				const SSO = sso_src?.slice(4, 6);
				if (Array.isArray(res_sso)) {
					const newSsoArray = res_sso.filter(
						(data: any) => parseInt(data.ID) === parseInt(SSO),
					);
					if (newSsoArray?.length) {
						setCurrentSSO(newSsoArray?.[0]);
					}
				}
			}

			try {
				if (Array.isArray(res_sso)) {
					const newSsoArray = res_sso.map((e: any) => {
						return {
							label: `${e.description}`,
							value: `sso:${e.ID}`,
							fields: e.FIELDS,
							url: e.url,
							Name: e.Name,
						};
					});
					if (newSsoArray?.length) {
						setSsoIdLinks(newSsoArray);
					}
				}
				if (showDrawer) {
					setShowOffCanvas(false);
					setSearchLinks('');
					setShowCompanyLinkDrawer({
						...showCompanyLinkDrawer,
						showDrawer: true,
						isweb: web_src !== '' ? true : false,
					});
				}
			} catch (error: any) {
				if (error.name === 'AbortError') {
					console.log('Getting Sso Data action aborted by user');
				} else {
					console.error('Getting Sso Data action error:', error);
				}
			}
		} else {
			setShowSnackbarHandler(Response?.MESSAGE, 'danger');
		}
		return connectedUserData;
	};

	const fetchNotifications = async () => {
		if (fetchNotificationsFunc) {
			await fetchNotificationsFunc();
		}
	};

	const openModal = async (type?: string, id?: string | number, title?: string, ...rest: any[]) => {
		if (!type || type !== 'snooze') {
			setShowActingAsModal(true);
		} else {
			setShowSnoozeModal(true);
			setSnoozeModalData({ id, title, ...rest });
		}
	};

	const closeModal = (type?: string, fetchBool?: boolean) => {
		if (!type || type !== 'snooze') {
			if (type === 'links') {
				setShowQuickLinksModal(false);
				setMenuType('links');
				setShowOffCanvas(true);
			} else {
				setShowActingAsModal(false);
			}
		} else {
			setShowSnoozeModal(false);
			if (fetchBool) {
				fetchNotifications();
			}
		}
	};

	const openLinksModal = async (type: string, linkItem: QuickLink, isUpdateSSOModal: boolean = false) => {
		setQuickLinksObject(linkItem);
		setQuickLinksType(type);
		// Open the Update my SSO Modal with prompt.
		if (isUpdateSSOModal) {
			setIsUpdateSSO(true);
		} else {
			setIsUpdateSSO(false);
		}
		if (type === 'delete') {
			setShowDeleteModal(true);
		} else {
			setShowQuickLinksModal(true);
		}
	};

	const deleteLinksmodal = async (linkItem: QuickLink) => {
		if (linkItem.src?.includes('sso:')) {
			const Response = await quickLinkService.deletePersonalLinks({
				publicid:
					linkItem?.publicid === 'Global' || linkItem?.publicid === 'global'
						? 'global'
						: user?.ActingAsPUBLICID,
				src: linkItem?.src,
			});
			if (Response?.STATUS === 0) {
				setMenuType('links');
				setShowOffCanvas(true);
				setShowDeleteModal(false);
				fetchQuickLinksCallBack();
				setShowSnackbarHandler(Response?.MESSAGE);
			} else {
				setShowSnackbarHandler(Response?.MESSAGE, 'danger');
			}
		} else {
			const Response = await quickLinkService.deletePersonalLinks({
				publicid:
					linkItem?.publicid === 'Global' || linkItem?.publicid === 'global'
						? 'global'
						: user?.ActingAsPUBLICID,
				src: linkItem?.src,
			});
			if (Response?.STATUS === 0) {
				setMenuType('links');
				setShowOffCanvas(true);
				setShowDeleteModal(false);
				fetchQuickLinksCallBack();
				setShowSnackbarHandler(Response?.MESSAGE);
			} else {
				setShowSnackbarHandler(Response?.MESSAGE, 'danger');
			}
		}
	};

	const fetchQuickLinksCallBack = () => {
		fetchQuickLinksFunc();
	};

	const setShowSnackbarHandler = (snackbarDescription: string, variant: string = 'success') => {
		setSnackbar({
			show: true,
			description: snackbarDescription,
			variant,
		});
	};

	const closeRightNav = () => {
		setShowOffCanvas(false);
		setSearchLinks('');
	};

	return (
		<>
			<BayDrawer
				alertAudio={alertAudio}
				alertFunc={() => updateNavSettings(!alertAudio)}
				bannerType={withBanners}
				dynamicWidth={
					menuType === 'links'
						? 406
						: menuType === 'settings' && isClientSettings
							? (isMobileView ? '100%' : '80%')
							: menuType === 'settings'
								? (isMobileView ? '100%' : 480)
								// notifications / feature / user fall through to BayDrawer's own
								// 360px default (`width={dynamicWidth || 360}`) — which is why this
								// is 0 and not a number. #940 set it to 480 to match Settings; that
								// was scope creep in a Settings-only PR. It made the My Account
								// drawer 33% wider than its content is laid out for, and a flat 480
								// with no `isMobileView` branch overflows a 375px phone by 105px.
								// If one of these three ever does want 480, give it its own branch
								// WITH a mobile case.
								: 0
				}
				footerClassName={`${
					menuType === 'settings' && isClientSettings
						? 'd-flex justify-content-start px-4 py-3 px-md-5 py-md-4'
						: menuType === 'settings'
							// Left inset comes from BayDrawer.scss's literal padding-left
							// instead of a px-md-4 step here; pe-md-4 keeps the right side.
							? 'd-flex align-items-center justify-content-start py-2 py-md-4 pe-3 pe-md-4'
							: ''
				}`}
				headerSize={menuType === 'settings' && isClientSettings ? 'lg' : 'sm'}
				footerContent={
					menuType === 'settings' ? (
						<Button
							// py-3/px-4 is the closest spacing-scale step to the target
							// button size, not an exact match — verify against Figma live.
							className={isClientSettings ? '' : 'rounded-1 py-3 px-4 my-auto'}
							variant="outline-secondary"
							onClick={() => closeRightNav()}
						>
							{t('close')}
						</Button>
					) : (
						<Button
							variant="outline-secondary w-75"
							onClick={() => {
								window.open(
									'https://forms.monday.com/forms/bfb2004ddda689c5266ac102590b2ed1?r=use1',
								);
							}}
						>
							{t('submitProductSuggestion')}
						</Button>
					)
				}
				id="nav_drawer"
				menuType={menuType}
				openBool={!!showOffCanvas}
				showFooter={((menuType === 'feature' || (menuType === 'settings' && isClientSettings)) && !!showFeatureButton) || (menuType === 'settings' && !isClientSettings)}
				title={navDrawerTitleEnum[menuType]}
				onCloseFunc={() => closeRightNav()}
				className={`${menuType} ${menuType === 'settings' && isClientSettings ? 'clientSettingsDrawer' : ''} ${menuType === 'settings' && !isClientSettings ? 'socialSettingsDrawer' : ''}`}
				// Nav drawers open over the app's own modals, so this backdrop has to clear
				// the modal layer or it hides behind the panel underneath. Token, not an
				// integer -- see CLAUDE.md on z-index.
				zIndexBackdrop="var(--bs-zindex-modal, 1055)"
			>
				{menuType === 'links' && (
					<QuickLinksMenu
						enableTestimonialTree={enableTestimonialTree}
						FilterLabel={FilterLabel}
						focusSearch={focusSearch}
						iqQuickLinksEdit={iqQuickLinksEdit}
						linkArrayList={linkArrayList}
						menuType={menuType}
						openModalFunc={openLinksModal}
						quickLinksDataObject={quickLinksDataObject}
						quickLinkService={quickLinkService}
						searchLinks={searchLinks}
						setFilterLabel={setFilterLabel}
						setFocusSearch={setFocusSearch}
						setSearchLinks={setSearchLinks}
						setShowFilterDropdown={setShowFilterDropdown}
						setShowSnackbarHandler={setShowSnackbarHandler}
						showFilterDropdown={showFilterDropdown}
						showLaunchpadButton={showLaunchpadButton}
						showOffCanvas={!!showOffCanvas}
						t={t}
						user={user}
					/>
				)}
				{menuType === 'notifications' && platformType !== 'social' && (
					<NotificationFeed
						feedArray={notificationsArray}
						openModalFunc={openModal as any}
						setArrayCount={setNotificationsArray}
						onCloseFunc={() => closeRightNav()}
					/>
				)}
				{menuType === 'notifications' && platformType === 'social' && (
					<NotificationFeedSocial
						feedArray={notificationsArray}
						fetchFunc={() => fetchNotifications()}
						user={user}
					/>
				)}
				{menuType === 'settings' && (platformType === 'social' || isClientSettings) && (
					<SettingsMenu
						settingsOptions={{
							...settingsOptions,
							appSettings,
							user,
							reqAccess,
							showAnnouncementBanners,
						}}
						t={t}
						toggleCloseFunc={() => closeRightNav()}
						platformType={platformType}
						onClose={closeRightNav}
					/>
				)}
				{menuType === 'user' && isClientSettings && (
					<MyAccountClient
						currentLanguage={currentLanguage}
						enableTranslations={enableTranslations}
						openModalFunc={() => openModal('actAs')}
						platform={platformType}
						reqAccess={reqAccess}
						selectLaunchpadSettingsData={selectLaunchpadSettingsData}
						showApiTokenButton={showApiTokenButton}
						showLaunchpadButton={showLaunchpadButton}
						supportedLanguages={supportedLanguages as string[]}
						t={t}
						toggleCloseFunc={() => closeRightNav()}
						updateLaunchpadApi={updateLaunchpadApi}
						user={user as any}
						weglotReady={weglotReady}
						onLanguageChange={onLanguageChange}
					/>
				)}
				{menuType === 'user' && platformType === 'social' && (
					<MyAccountSocial
						openModalFunc={() => openModal()}
						platform={platformType}
						reqAccess={reqAccess}
						selectLaunchpadSettingsData={selectLaunchpadSettingsData}
						showLaunchpadButton={showLaunchpadButton}
						showLaunchpadUpgradeButton={showLaunchpadUpgradeButton}
						t={t}
						toggleCloseFunc={() => closeRightNav()}
						updateLaunchpadApi={updateLaunchpadApi}
						user={user}
					/>
				)}
				{menuType === 'feature' && showFeatureButton && (
					<FeatureMenu
						featureList={featureList}
						openModalFunc={() => openModal()}
						productStages={productStages}
						toggleCloseFunc={() => closeRightNav()}
						toggleFunc={setFeatureFunc}
					/>
				)}
			</BayDrawer>

			{showActingAsModal && (
				<ActAsModal
					platform={platformType}
					showModal={showActingAsModal}
					t={t}
					user={user}
					onHideFunc={() => closeModal()}
				/>
			)}

			<BayModal
				buttonText={t('yesDelete')}
				cancelText={t('cancel')}
				id="deletePersonalLinkModal"
				show={showDeleteModal}
				size="lg"
				style={{ margin: '24.5vh auto' }}
				submitFunc={() => {
					deleteLinksmodal(quickLinksObject!);
					setShowOffCanvas(true);
				}}
				title={t('sure')}
				translate={t}
				variant="danger"
				onHideFunc={() => {
					setShowOffCanvas(true);
					setShowDeleteModal(false);
				}}
			>
				<div className="pt-0">{t('deletePersonalQlNotes')}</div>
			</BayModal>

			{showQuickLinksModal && (
				<QuickLinksModal
					editQuickLinksDataUser={editQuickLinksDataUser}
					fetchQuickLinksCallBack={() => fetchQuickLinksCallBack()}
					globalQLData={globalQLData}
					isUpdateSSO={isUpdateSSO}
					linkItem={quickLinksObject}
					linksArray={quickLinksDataObject}
					modalType={quickLinksType}
					openModalFunc={openLinksModal}
					quickLinkService={quickLinkService as any}
					setShowOffCanvas={setShowOffCanvas}
					setShowSnackbarHandler={setShowSnackbarHandler}
					showModal={showQuickLinksModal}
					ssoIdLinks={ssoIdLinks}
					t={t}
					user={user}
					onHideFunc={() => {
						closeModal('links');
						setShowOffCanvas(true);
					}}
				/>
			)}

			{showSnoozeModal && (
				<SnoozeModal
					data={snoozeModalData as any}
					notificationsArray={notificationsArray}
					setArrayCount={setNotificationsArray}
					showModal={showSnoozeModal}
					onHideFunc={closeModal}
				/>
			)}

			{showCompanyLinkDrawer?.showDrawer && (
				<AddEditCompanyLinkDrawer
					currentData={editQuickLinksData}
					currentSSO={currentSSO}
					fetchQuickLinksCallBack={() => fetchQuickLinksCallBack()}
					groupList={groupIdArray}
					handleWebDrawerClose={handleWebDrawerClose}
					isSsoQuickLink={!showCompanyLinkDrawer?.isweb}
					officeList={officeIdArray}
					quickLinkService={quickLinkService as any}
					setShowSnackbarHandler={setShowSnackbarHandler}
					showCompanyLinkDrawer={showCompanyLinkDrawer as any}
					ssoList={ssoIdLinks}
					t={t}
					userSingleSignOnParameters={
						editQuickLinksDataUser?.SingleSignOn_Parameters
							? JSON.parse(editQuickLinksDataUser?.SingleSignOn_Parameters)
							: {}
					}
				/>
			)}

			<BayToast
				show={snackbar.show}
				text={snackbar.description}
				variant={snackbar.variant}
				onClose={() => setSnackbar({ ...snackbar, show: false })}
			/>
		</>
	);
};

export default BayNavDrawer;
